module.exports = __webpack_public_path__ + "static/media/01.954ef605.png";